import axios from "axios"
import { env } from '../constants'


/* Messages */
export const messages = token => {
    const uri = `${env.startpoint}support/messages`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    /* A request that never reached the server has no response at all — hand back a shape
       the caller can read instead of undefined, so `response.status` can never throw */
    return axios.get(uri, headers).then(response => response).catch(error => error.response ? error.response : { status: 0, data: null })
}